import { BasketService } from "@/generated/services/BasketService";
import { useQuery } from "@tanstack/react-query";

export function useFetchBasket(memberId: number) {
  return useQuery({
    queryKey: ["basket", memberId],
    enabled: !!memberId, // only run when memberId is valid
    refetchOnMount: "always", // Refetch whenever the component mounts
    queryFn: async () => {
      if (!memberId) throw new Error("Invalid member ID");

      const response = await BasketService.getMembersBasket(
        memberId,
        Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
      );
      // Ensure the response is always an array
      return Array.isArray(response) ? response : [];
    },
  });
}
